import type { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import type { CircularProgressProps } from '@mui/material/CircularProgress';
import MuiCircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress';
import Fade from '@mui/material/Fade';

export default function CircularProgress({
  containerProps,
  show,
  ...props
}: CircularProgressProps & { show: boolean; containerProps?: SxProps }) {
  return (
    <Fade in={show}>
      <Box position="relative" display="inline-flex" sx={containerProps}>
        <MuiCircularProgress
          variant="determinate"
          sx={{
            color: (theme) => theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
          }}
          size={12}
          thickness={4}
          {...props}
          value={100}
        />
        <MuiCircularProgress
          variant="indeterminate"
          disableShrink
          sx={{
            color: (theme) => theme.palette.info.main,
            animationDuration: '1000ms',
            position: 'absolute',
            left: 0,
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: 'round',
            },
          }}
          size={12}
          thickness={4}
          {...props}
          value={20}
        />
      </Box>
    </Fade>
  );
}
